import { redirect } from 'react-router-dom'
import { canAccessRoute } from '@/usecases/auth/canAccessRoute'
import type { AuthenticationPort } from '@/domains/auth/AuthenticationPort'
import type { LocationPort } from '@/domains/auth/LocationPort'

export const runAuthGuard = async ({
  auth,
  location,
  authPages,
}: {
  auth: AuthenticationPort
  location: LocationPort
  authPages: string[]
}) => {
  const decision = await canAccessRoute({ auth, location, authPages })
  switch (decision.type) {
    case 'allow':
      return null
    case 'redirect':
      return redirect(decision.to)
    case 'login':
      await auth.login(decision.returnTo)
      return null
  }
}
